module.exports = __webpack_public_path__ + "img/雪山1_1.efe9f0d5.jpg";